module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": _vm.title
    }
  }), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "alert alert-info text-center",
    staticStyle: {
      "margin-bottom": "65px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "fa fa-info-circle fa-2x",
    staticStyle: {
      "vertical-align": "middle"
    }
  }), _vm._v("\n    "), _c('span', {
    staticClass: "my-text"
  }, [_c('strong', [_vm._v("The following forms are samples and not for use.")])])]), _vm._v(" "), _c('div', {
    staticClass: "document-header first"
  }, [_vm._v("GATA Uniform Grant Agreement Template")]), _vm._v(" "), _c('div', {
    staticClass: "document-text"
  }, [_vm._v("\nView an example of a basic ICJIA grant agreement.\n An actual grant agreement also will have program- and grantee-specific information.\n ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Agreement_Template/GATA_UNIFORM_GRANT_AGREEMENT_040517.pdf"
    }
  }, [_vm._v("\n  GATA Uniform Grant Agreement »")])])]), _vm._v(" "), _c('div', {
    staticClass: "document-header"
  }, [_vm._v("ICJIA Uniform Budget Template")]), _vm._v(" "), _c('div', {
    staticClass: "document-text"
  }, [_vm._v("View examples of the ICJIA Uniform Budget Template documents.")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Budget_Instructions_(General).pdf"
    }
  }, [_vm._v("Budget Instructions (General).pdf »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Budget_Instructions_(ICJIA).pdf"
    }
  }, [_vm._v("Budget Instructions (ICJIA).pdf»")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_A_ICJIA_Funds.pdf"
    }
  }, [_vm._v("Section A ICJIA Funds »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_A_Indirect_Cost_Info.pdf"
    }
  }, [_vm._v("Section A Indirect Cost Info")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_B_Match_Funds.pdf"
    }
  }, [_vm._v("Section B Match Funds »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Applicant_Certification.pdf"
    }
  }, [_vm._v("Applicant Certification »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_FFATA_Form.pdf"
    }
  }, [_vm._v("FFATA Form »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_C1_Personnel.pdf"
    }
  }, [_vm._v("Section C1 Personnel »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_C2_Fringe_Benefits.pdf"
    }
  }, [_vm._v("Section C2 Fringe Benefits »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_C3_Travel.pdf"
    }
  }, [_vm._v("Section C3 Travel »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_C4_Equipment.pdf"
    }
  }, [_vm._v("Section C4 Equipment.pdf »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_C5_Supplies.pdf"
    }
  }, [_vm._v("Section C5 Supplies.pdf »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_C6_Contractual.pdf"
    }
  }, [_vm._v("Section C6 Contractual.pdf »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_C7_Indirect_Costs.pdf"
    }
  }, [_vm._v("Section C7 Indirect Costs.pdf »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_C_Budget_Summary.pdf"
    }
  }, [_vm._v("Section C Budget Summary.pdf »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Agency_Approval.pdf"
    }
  }, [_vm._v("Agency Approval.pdf »")])])]), _vm._v(" "), _c('div', {
    staticClass: "document-header"
  }, [_vm._v("ICJIA Fiscal Reports")]), _vm._v(" "), _c('div', {
    staticClass: "document-text"
  }, [_vm._v("View a Monthly or a Quarterly Fiscal Report in the required reporting format. Reporting deadlines vary by grant.")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Fiscal_Reporting/Grantee_Fiscal_Report_1-4_Quarter_with_Close_Out_with_Cents_4_2017_SAMPLE.pdf"
    }
  }, [_vm._v("Grantee Fiscal Report 1-4 Quarter with Close Out with Cent 04-2017 »")])])]), _vm._v(" "), _c('div', {
    staticClass: "document-header"
  }, [_vm._v("Risk Assessment Form")]), _vm._v(" "), _c('div', {
    staticClass: "document-text"
  }, [_vm._v("View an example of a programmatic Risk Assessment. The Risk Assessment Form may include additional questions specific to a grant program.")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Risk_Assessment_Form/Programmatic_Risk_Assessment_Questionnaire_030817.pdf"
    }
  }, [_vm._v("Programmatic Risk Assessment Questionnaire 03-08-2017.pdf »")])])]), _vm._v(" "), _c('div', {
    staticClass: "document-header"
  }, [_vm._v("Uniform Application")]), _vm._v(" "), _c('div', {
    staticClass: "document-text"
  }, [_vm._v("View the ICJIA Uniform Application for Grant Assistance.")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Uniform_Application/ICJIA_Uniform_Application_for_Grant_Assistance_110216.pdf"
    }
  }, [_vm._v("Uniform Application for Grant Assistance 11-02-2016 »")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4db5c406"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Documents.vue
// module id = 373
// module chunks = 0